import { useAccountModel } from "./useAccountModel";
import { AccountListView } from "./account-list-view";
import { UserApiService } from "app/services";

const AccountListing = () => {
  const userService = new UserApiService();
  const model = useAccountModel({ userService });

  return <AccountListView {...model} />;
};

export default AccountListing;
